<template>
  <div v-if="contact" class="space-y-4 pb-4">
    <BaseButton
      v-if="$membershipHasPermissionTo('create email messages')"
      primary
      small
      @click="handleWriteEmail"
    >
      Write Email
    </BaseButton>

    <EmailMessageList ref="emailMessageList" :contact-request="contactRequest" :contact="contact" />
  </div>
</template>

<script>
import { contactsClient } from '@/api/clients';
import EmailMessageList from './EmailMessageList.vue';

export default {
  components: {
    EmailMessageList,
  },
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      contact: null,
    };
  },
  created() {
    this.loadContact();
  },
  methods: {
    async loadContact() {
      try {
        const response = await contactsClient.read(this.contactRequest.contactId, {
          include: 'primaryEmailAddress,emailAddresses',
        });

        this.contact = response.data;
      } catch (error) {
        //
      }
    },
    handleWriteEmail() {
      this.$modal.show({
        component: () =>
          import(
            '@/components/ContactEmailMessage/WriteEmailMessageDialog/WriteEmailMessageDialog.vue'
          ),
        props: {
          contact: this.contact,
          contactRequest: this.contactRequest,
        },
        on: {
          saved: () => {
            this.$refs.emailMessageList.fetchData();
          },
          sent: () => {
            this.$refs.emailMessageList.fetchData();
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
